
import Vue from 'vue';
import { Icon, Tooltip } from '@descomplica/vue-components';
import { ListModel } from '@descomplica/dex-models';
import Card from './Card.vue';
import ProgressBar from '../progress/ProgressBar.vue';
import ListCardSkeleton from '../skeletons/ListCardSkeleton.vue';
import { isMobileDevice } from '@/helpers/mobile';

interface Stats {
  current: number;
  max: number;
}

export default Vue.extend({
  components: {
    Card,
    Icon,
    ProgressBar,
    ListCardSkeleton,
    Tooltip,
  },
  props: {
    list: {
      default: () => {},
      type: Object as Vue.PropType<ListModel | any>,
    },
    classroomSlug: {
      required: true,
      type: String,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
  },
  data: () => {
    return {
      showSkeleton: true,
      showTooltip: false,
    };
  },
  computed: {
    iconOfListItemType(): Object {
      return {
        video: 'play',
        text: 'file',
        question: 'listCheck',
        trivia: 'comment',
        practice: 'practicalExercises',
      };
    },
    listItemTypes(): string[] {
      return Object.keys(this.iconOfListItemType);
    },
    isMobileDevice(): boolean {
      return isMobileDevice();
    },
  },
  watch: {
    isLoading: {
      immediate: true,
      handler(newValue) {
        this.showSkeleton = newValue;
      },
    },
  },
  methods: {
    formatListItemLabel(listItemType: string): string {
      if (!this.isListItemTypeValid(listItemType)) {
        return '';
      }

      const stats = this.getStats(listItemType);

      return stats ? `${stats.current}/${stats.max} ${this.$tc(listItemType, stats.max)}` : '';
    },
    isThereListItem(listItemType: string): boolean {
      const stats = this.getStats(listItemType);
      return !!stats && stats.max > 0;
    },
    getStats(listItemType: string): Stats {
      const index = `${listItemType}Stats`;
      const stats: Stats = this.list[index];
      return stats;
    },
    isListItemTypeValid(type: string): boolean {
      return this.listItemTypes.includes(type);
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    stopAndPreventEvent(event: Event) {
      event.stopPropagation();
      event.preventDefault();
    },
    infoButtonListeners(): Object {
      if (this.isMobileDevice) {
        return {
          click: (event: Event) => {
            this.stopAndPreventEvent(event);
            this.toggleTooltip();
          },
        };
      }
      return {
        mouseenter: this.toggleTooltip,
        mouseleave: this.toggleTooltip,
        click: this.stopAndPreventEvent,
      };
    },
  },
});
